<template>
  <!-- 读取第三方数据 -->
  <div class="read">
    <a-modal
        v-model:visible="readInfo.show"
        :footer="null"
        :title="readInfo.title"
        width="40%"
    >
      <div class="read-list">
        <a-spin :spinning="readSpin">
          <div v-for="item in otaList" :key="item.cota_id" class="list-cell">
            <div class="cell-name">
              <a-avatar :src="item.logo"/>
              <span style="margin-left: 10px">{{ item.ota_name }}</span>
            </div>
            <div class="cell-phone">{{ item.name }}</div>
            <div class="cell-status">
              <span v-if="item.ota_status == 1" class="f-c-green"> 在线 </span>
              <span v-else-if="item.ota_status == 2" class="f-c-red">
                离线
              </span>
              <span v-else-if="item.ota_status == 3"> 密码错误 </span>
            </div>
            <div v-if="item.ota_status == 1" class="oper-s">
              <div v-for="it in item.sync" :key="it.type" class="cell-oper">
                <div class="oper_last">{{ diffTime(it.sync_time) }}</div>
                <div class="oper_btn">
                  <a-button
                      :disabled="it.countdown > 0 || readLoding"
                      style="padding: 0"
                      type="link"
                      @click="handleRead(it)"
                  >{{
                      it.countdown > 0 ? readOrderTime(it.countdown) : it.name
                    }}
                  </a-button
                  >
                </div>
              </div>
            </div>
            <div v-else class="oper-s">
              <div class="cell-oper">
                <a-button
                    style="padding: 0; color: #ff0000"
                    type="link"
                    @click="handleAgainLogin(item)"
                >重新登录
                </a-button
                >
              </div>
            </div>
          </div>
        </a-spin>
      </div>
    </a-modal>
  </div>

  <!-- 民宿 -->
  <a-modal v-model:visible="msShow" title="民宿" @ok="handleMsConfirm">
    <div class="msClass">
      <a-form
          ref="msFormRef"
          :model="msForm"
          autocomplete="off"
      >
        <a-form-item
            :rules="[{ required: true, message: '请输入账号' }]"
            label="账号"
            name="account"
        >
          <a-input v-model:value="msForm.account"/>
        </a-form-item>

        <a-form-item
            :rules="[{ required: true, message: '请输入密码' }]"
            label="密码"
            name="pwd"
        >
          <a-input-password v-model:value="msForm.pwd"/>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
import {onMounted, onUnmounted, reactive, toRefs, watch} from "vue";
import {otaAccountList, otaAdd} from "@/api/api";
import {message} from "ant-design-vue";
import axios from "@/utils/request";
import useUtils from "@/hooks/useUtils.js";
import store from "@/store/pms/landlord/index";

export default {
  props: {
    params: {
      type: Object,
      default: Object,
    },
  },
  emits: ["refresh"],
  setup(props, {emit}) {
    const {diffTime} = useUtils();

    const reads = reactive({
      readInfo: props.params,
      otaInfo: "",
      timer: "",
      otaList: [],
      readSpin: false,
      msShow: false,
      msFormRef: "",
      msForm: {
        account: "",
        pwd: "",
      },

      // 民宿确认添加
      handleMsConfirm() {
        reads.msFormRef.validate().then(() => {
          otaAdd({
            name: reads.msForm.account,
            pwd: reads.msForm.pwd,
          }).then((res) => {
            message.success(res.msg);
            reads.msShow = false;
            reads.msFormRef.resetFields();
            reads.getOtaList();
          });
        });
      },

      readLoding: false,
      // 读取
      handleRead(v) {
        reads.readLoding = true;
        axios({
          method: v.method,
          url: v.url,
          [v.method == "get" ? "params" : "data"]: v.param,
        })
            .then((res) => {
              message.success(res.msg);
              reads.getAllData();
              emit("refresh");
            })
            .finally(() => {
              reads.readLoding = false;
            });
      },

      // 初始化
      getAllData() {
        // 获取OTA渠道信息
        reads.readSpin = true;
        otaAccountList({
          sync_ids: props.params.sync_ids,
        })
            .then((res) => {
              reads.otaList = res.data;
            })
            .finally(() => {
              reads.readSpin = false;
            });
      },

      readOrderTime(time) {
        return time == 0 ? "" : `${time}秒后重试`;
      },

      countDown() {
        reads.timer = setInterval(() => {
          reads.otaList.forEach((item) => {
            item.sync.forEach((it) => {
              if (it.countdown > 0) {
                it.countdown--;
              }
            });
          });
        }, 1000);
      },
    });

    // 登录
    const logins = reactive({
      loginTimer: "",

      // 重新登录
      handleAgainLogin(item) {
        if (item.ota_id == 6) {
          return;
        }
        store.commit("openWindow", item);
      },
    });

    onMounted(() => {
      reads.countDown();
    });
    onUnmounted(() => {
      clearInterval(reads.timer);
    });

    watch(
        () => props.params.show,
        (n) => {
          if (n) {
            reads.getAllData();
          }
        }
    );

    return {
      diffTime,
      ...toRefs(logins),
      ...toRefs(reads),
    };
  },
};
</script>

<style lang="scss" scoped>
.read-list {
  .list-cell {
    border-radius: 6px;
    display: flex;
    align-items: center;
    background-color: #f7f8fa;
    padding: 10px 20px;
    margin-bottom: 5px;

    &:last-child {
      margin-bottom: 0;
    }

    .cell-name {
      flex: 3;
    }

    .cell-phone {
      flex: 2;
    }

    .cell-status {
      flex: 2;
    }

    .oper-s {
      flex: 3;
      display: flex;
      flex-wrap: wrap;

      .cell-oper {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .oper_last {
          color: #999;
        }

        .oper_btn {
        }

        width: 56px;
        color: #0094ff;
        margin-right: 4px;

        &:last-child {
          margin: 0;
        }
      }
    }
  }
}

// 登录
.login {
  padding: 20px 0;

  .login-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 30px;

    .title-logo {
    }

    .title-name {
    }
  }

  .login-form {
    margin-bottom: 10px;
  }

  .login-btn {
  }
}
</style>
